import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2453106473/src/client-hcap/components/harmonized-hcap-data/search/variable-search-home.tsx");
